import ChatView from './ChatView'; 
import ChatRow from './ChatRow'; 


export {
    ChatView,
    ChatRow
}


// WEBPACK FOOTER //
// ./src/components/chatview/index.js